module.exports = __webpack_public_path__ + "media/images/sort_desc-c4196d3286cc33244c83af3398675a6a.png";